// extracted by mini-css-extract-plugin
module.exports = {"container":"e_jA","msrp":"e_kA","save":"e_lA","discount":"e_mA","price":"e_nA"};